import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./i18n";
import i18n from "./i18n";

//  Set ONLY language on the <html> tag (do NOT touch dir)
const setHtmlLang = (lng) => {
  document.documentElement.lang = lng || "en";
};

setHtmlLang(i18n.language || "en");

i18n.on("languageChanged", (lng) => {
  setHtmlLang(lng);
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
